// @flow
import { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Container from '../CatalogFiltersContainer';
import MetalFilters from './MetalFilters';
import StyleFilters from './StyleFilters';
import DesignFilters from './DesignFilters';
import ShapeFilters from './ShapeFilters';
import PriceFilters from './PriceFilters';

import css from '@styles/ringFilters';

function Filters ({ priceExtents }) {
  const filters = useSelector((state) => state.settingSearchFilters);
  const [openTab, setOpenTab] = useState(null);
  const dispatch = useDispatch();

  const handleFilterCheckToggle = useCallback((group, filterName) => {
    dispatch({
      type: 'TOGGLE_SETTING_FILTER',
      payload: {
        group,
        filterName
      }
    });

    dispatch({ type: 'SYNC_URI_WITH_SETTING_FILTERS' });
  }, []);

  const handleFilterRadioToggle = useCallback((filterName, value) => {
    dispatch({
      type: 'SET_SETTING_FILTER',
      payload: {
        filterName,
        value
      }
    });

    dispatch({ type: 'SYNC_URI_WITH_SETTING_FILTERS' });
  }, []);

  const handlePriceFilterChange = useCallback(
    (values) => {
      dispatch({
        type: 'SET_SETTING_FILTER',
        payload: {
          filterName: 'price',
          value: values
        }
      });

      dispatch({ type: 'SYNC_URI_WITH_SETTING_FILTERS' });
    },
    [priceExtents]
  );

  const toggleActiveTab = useCallback(
    (tab) => {
      if (openTab === tab) {
        setOpenTab(null);
      } else {
        setOpenTab(tab);
      }
    },
    [openTab]
  );

  const handleToggleShapeTab = useCallback(
    () => {
      toggleActiveTab('shape');
    },
    [toggleActiveTab]
  );

  const handleToggleMetalTab = useCallback(
    () => {
      toggleActiveTab('metal');
    },
    [toggleActiveTab]
  );

  const handleToggleStyleTab = useCallback(
    () => {
      toggleActiveTab('style');
    },
    [toggleActiveTab]
  );

  const handleToggleDesignTab = useCallback(
    () => {
      toggleActiveTab('design');
    },
    [toggleActiveTab]
  );

  const handleTogglePriceRangeTab = useCallback(
    () => {
      toggleActiveTab('priceRange');
    },
    [toggleActiveTab]
  );

  return (
    <Container className={css.container}>
      <ShapeFilters
        selectedItem={filters.shape}
        onFilterChange={handleFilterRadioToggle}
        onToggle={handleToggleShapeTab}
        isOpen={openTab === 'shape'}
        key="shape-filters"
      />
      <MetalFilters
        selectedItems={filters.metal}
        onFilterCheckToggle={handleFilterCheckToggle}
        onToggle={handleToggleMetalTab}
        isOpen={openTab === 'metal'}
        key="metal-filters"
      />

      <br />

      <StyleFilters
        selectedItems={filters.style}
        onFilterCheckToggle={handleFilterCheckToggle}
        onToggle={handleToggleStyleTab}
        isOpen={openTab === 'style'}
        key="style-filters"
      />

      <br />

      <DesignFilters
        selectedItems={filters.design}
        onFilterCheckToggle={handleFilterCheckToggle}
        onToggle={handleToggleDesignTab}
        isOpen={openTab === 'design'}
        key="design-filters"
      />

      <br />

      <PriceFilters
        priceValues={filters.price}
        priceExtents={priceExtents}
        sortDirection={filters.sort}
        onPriceFilterChange={handlePriceFilterChange}
        onRadioFilterChange={handleFilterRadioToggle}
        onToggle={handleTogglePriceRangeTab}
        isOpen={openTab === 'priceRange'}
        key="price-filters"
      />
    </Container>
  );
}

export default Filters;
